import { Link } from "react-router-dom";
import { Lock, CheckCircle2 } from "lucide-react";

const ACT_IMAGES = { 1: "/tms/act1.jpg", 2: "/tms/act2.jpg", 3: "/tms/act3.jpg", 4: "/tms/act4.jpg", 5: "/tms/act5.jpg", 6: "/tms/act6.jpg", 7: "/tms/act7.jpg" };

export function TMSCurriculum({ acts, enrolled, isLoading }) {
  return (
    <section id="curriculum" data-testid="tms-curriculum-section" className="bg-card border-y border-border py-20 md:py-28">
      <div className="max-w-[1300px] mx-auto px-6 md:px-12">
        <p className="text-xs uppercase tracking-[0.3em] text-[#5e1420] mb-3">The Curriculum</p>
        <h2 className="font-display text-2xl md:text-4xl font-medium mb-3">Seven Acts. 106 Lessons.</h2>
        <p className="text-textSecondary max-w-2xl mb-14">
          Lesson I.1.1 is open to everyone. Enroll once to unlock every remaining lesson, permanently.
        </p>

        {isLoading && <p className="text-textSecondary">Loading curriculum…</p>}

        <div className="space-y-16">
          {acts?.map((act) => (
            <div key={act.id} data-testid={`tms-act-block-${act.number}`} className="grid grid-cols-1 md:grid-cols-[180px_1fr] gap-8 items-start">
              <div className="flex md:flex-col items-center md:items-start gap-4">
                <img src={ACT_IMAGES[act.number]} alt={`Act ${act.number}`} className="w-20 h-20 md:w-32 md:h-32 object-contain" />
                <div>
                  <p className="text-xs font-meta uppercase tracking-wide text-[#c9962c]">Act {act.number}</p>
                  <h3 className="text-lg font-subtitle">{act.title}</h3>
                </div>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
                {act.modules.map((m) => (
                  <div key={m.id} data-testid={`tms-module-${m.id}`} className="border border-border p-4 bg-background">
                    <p className="text-xs uppercase tracking-wide text-textSecondary mb-2">{m.title}</p>
                    <ul className="space-y-1.5">
                      {m.lessons.map((l) =>
                        l.locked ? (
                          <li key={l.id} data-testid={`tms-lesson-locked-${l.id}`} className="text-xs flex items-center gap-1.5 text-muted-foreground/60">
                            <Lock className="w-3 h-3 shrink-0" />
                            <span>Lesson {l.id}</span>
                          </li>
                        ) : (
                          <li key={l.id}>
                            <Link
                              to={`/themuscleschool/lessons/${l.id}`}
                              data-testid={`tms-lesson-link-${l.id}`}
                              className="text-xs flex items-center gap-1.5 hover:text-primary"
                            >
                              {l.is_free ? <CheckCircle2 className="w-3 h-3 shrink-0 text-[#5e1420]" /> : null}
                              <span className={l.status === "import_pending" ? "opacity-40" : ""}>{l.title}</span>
                            </Link>
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
